
import { scrollTo } from '../../../../application/typescript/utils/utils';


class HeadingContactCpt {
  constructor() {
    this._init();
  }

  _init() {
    const scrollBtn = document.querySelector('.heading-contact-cpt__scroll');
    const target = document.querySelector('.single-contact__infos');

    if (scrollBtn && target) {
      scrollBtn.addEventListener('click', (e) => {
        e.preventDefault();
        scrollTo(target);
      });
    };

  }
}

export const headingContactCpt = new HeadingContactCpt();
